import type { EntityTone } from './entity-summaries-data.js';

/** Semantic classes per entity tone (theme tokens only, so light and dark both read). */
export const TONE_CLASS: Record<EntityTone, { border: string; fill: string; text: string; chip: string }> = {
  frontend: {
    border: 'border-info',
    fill: 'bg-info-muted/40',
    text: 'text-info-text',
    chip: 'border-info/40 bg-info-muted text-info-text',
  },
  backend: {
    border: 'border-success',
    fill: 'bg-success-muted/40',
    text: 'text-success-text',
    chip: 'border-success/40 bg-success-muted text-success-text',
  },
  database: {
    border: 'border-purple',
    fill: 'bg-purple-muted/40',
    text: 'text-purple-text',
    chip: 'border-purple/40 bg-purple-muted text-purple-text',
  },
  cloud: {
    border: 'border-warning',
    fill: 'bg-warning-muted/40',
    text: 'text-warning-text',
    chip: 'border-warning/40 bg-warning-muted text-warning-text',
  },
  security: {
    border: 'border-danger',
    fill: 'bg-danger-muted/40',
    text: 'text-danger-text',
    chip: 'border-danger/40 bg-danger-muted text-danger-text',
  },
  bus: {
    border: 'border-teal',
    fill: 'bg-teal-muted/40',
    text: 'text-teal-text',
    chip: 'border-teal/40 bg-teal-muted text-teal-text',
  },
  external: {
    border: 'border-border-strong',
    fill: 'bg-surface-alt',
    text: 'text-body',
    chip: 'border-border bg-surface-hover text-body',
  },
};
